import React, { useState } from 'react';
import {
    Box,
    Container,
    Heading,
    Text,
    Flex,
    Button,
    FormControl,
    FormLabel,
    Input,
    Alert,
    AlertIcon,
    AlertTitle,
    Switch,
    useBreakpointValue,
    Grid,
    GridItem,
    SimpleGrid,
    Stack,
    HStack,
    VStack,
    Spacer,
    Center,
    Square,
    Circle,
    Image,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Badge,
    Avatar,
    AvatarGroup,
    Divider,
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useColorModeValue,
    useColorMode,
} from '@chakra-ui/react';
import { FiMenu, FiHeart, FiStar, FiShoppingCart, FiUser, FiSettings } from 'react-icons/fi';

const MySandbox: React.FC = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Box flex="1" zIndex={1} overflow="hidden">
                <Container maxW="container.xl" p={4}>
                    <Heading mb={4}>My Sandbox</Heading>
                    <Text mb={8}>This is a sandbox page for testing components.</Text>
                    {/* Add your sandbox content here */}
                    
                </Container>
            </Box>
        </Box>
    )
}
export default MySandbox;